import { createSlice } from "@reduxjs/toolkit";
import {
  today,
  weekAgo,
  weekAgo2,
  weekAgo3,
  yesterday,
} from "../../../utils/dateUtils";
import { monitoringApi } from "./monitoring.api";
import { MonitoringFilterItemType, MonitoringStore } from "./types";

export interface IMonitorFilter {
  type: MonitoringFilterItemType | "index";
  value: string | string[];
}

export const todayDateKeys: IMonitorFilter[] = [
  { type: "Start", value: today.format("YYYY-MM-DD") },
  { type: "Finish", value: today.format("YYYY-MM-DD") },
  { type: "FObjects", value: [] },
];

export const initDateKeys: IMonitorFilter[] = [
  { type: "Start", value: weekAgo.format("YYYY-MM-DD") },
  { type: "Finish", value: yesterday.format("YYYY-MM-DD") },
  { type: "Start2", value: weekAgo3.format("YYYY-MM-DD") },
  { type: "Finish2", value: weekAgo2.format("YYYY-MM-DD") },
  { type: "FObjects", value: [] },
];

const initialState: MonitoringStore = {
  filter: initDateKeys,
  pointsOrders: [],
  statuses: [],
};

const monitoringSlice = createSlice({
  name: "monitoring",
  initialState,
  reducers: {
    setFilter: (state, { payload }) => {
      state.filter = payload;
    },
    setClearFilter: (state) => {
      state.filter = initDateKeys;
    },
    changePointOrders: (state, { payload }) => {
      state.pointsOrders = payload;
    },
    setStatuses: (state, { payload }) => {
      state.statuses = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      monitoringApi.endpoints.getPointAll.matchFulfilled,
      (state, { payload }) => {
        state.pointsOrders = payload;
      },
    );
  },
});

export const { setFilter, setClearFilter, changePointOrders, setStatuses } =
  monitoringSlice.actions;

export default monitoringSlice.reducer;
